function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from 'modules/AmbulatoryGlucoseProfile/messages';
import styles from './HeaderSection.pcss';
var _React_Component;
class HeaderSection extends (_React_Component = React.Component) {
    render() {
        const { firstName, lastName } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.headerSection,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "reportName",
                    children: /*#__PURE__*/ _jsxs("h1", {
                        className: "reportName__title",
                        children: [
                            /*#__PURE__*/ _jsx("b", {
                                children: "AGP"
                            }),
                            " ",
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.report)),
                            ": ",
                            /*#__PURE__*/ _jsx("b", {
                                children: "BGM"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "reportInfo",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "reportInfo__row",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "reportInfo__rowTitle",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.name))
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "reportInfo__rowContent",
                                    children: [
                                        firstName,
                                        " ",
                                        lastName
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "reportInfo__row",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "reportInfo__rowTitle",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.mrn))
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "reportInfo__rowContent"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(HeaderSection, "propTypes", {
    // Explicit props
    firstName: PropTypes.string,
    lastName: PropTypes.string
});
export default withStyles(styles)(HeaderSection);
